import { ChangeEvent } from 'react'
import useSWR from 'swr'
import {
  CourseType,
  ProvisionalDrivingLicenseDescriptions,
} from '@/src/@types/admin'
import { get } from '@/src/BlinkAdminApiClient'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
} from '@/src/components/core/Dialog'
import { Select } from '@/src/components/core/Select'
import Picture from '@/src/components/elements/Picture'

export default function LicenseDialog({
  show,
  close,
  userSelectedCanton,
  setUserSelectedCanton,
}: {
  show: boolean
  close: () => void
  userSelectedCanton: CourseType['provisionalDrivingLicenseDescription']
  setUserSelectedCanton: (
    newCanton: CourseType['provisionalDrivingLicenseDescription']
  ) => void
}) {
  const { data: provisionalDrivingLicenseDescriptions } = useSWR(
    'provisional-driving-license-descriptions',
    async () =>
      await get<ProvisionalDrivingLicenseDescriptions>(
        '/website/v2/provisional-driving-license-descriptions'
      )
  )

  return (
    <Dialog
      open={show}
      onOpenChange={(open) => {
        if (!open) close()
      }}
    >
      <DialogContent>
        <DialogHeader title="Lernfahrausweisnummer" />
        <DialogBody>
          {provisionalDrivingLicenseDescriptions && (
            <Select
              label="In welchem Kanton wurde dein Lernfahrausweis ausgestellt?"
              labelType="block"
              color={
                process.env.NEXT_PUBLIC_STATAMIC_SITE_HANDLE === 'flch'
                  ? 'white-blue'
                  : 'blue'
              }
              value={userSelectedCanton?.canton.short}
              onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                const newCanton =
                  provisionalDrivingLicenseDescriptions.cantons.find(
                    (c) => c.canton.short === e.target.value
                  )
                if (newCanton) {
                  setUserSelectedCanton(newCanton)
                }
              }}
            >
              <option value="">Wähle deinen Kanton</option>
              {provisionalDrivingLicenseDescriptions.cantons.map((location) => (
                <option
                  key={location.canton.short}
                  value={location.canton.short}
                >
                  {location.canton.german}
                </option>
              ))}
            </Select>
          )}
          {userSelectedCanton && userSelectedCanton.image ? (
            <div className="relative mt-4 h-[500px] w-full">
              <Picture
                permalink={userSelectedCanton.image}
                sizes="500px"
                alt={`Lernfahrausweisnummer Kanton ${userSelectedCanton.canton.german}`}
                fill
                className="object-contain object-top"
              />
            </div>
          ) : (
            <p className="mt-4 text-sm">
              Für diesen Kanton haben wir leider aktuell noch kein Muster.
            </p>
          )}
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
